import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class TargetMetric extends Field {
  static attributesForModel() {
    return ['targetMetric'];
  }

  get title() {
    return 'Target metric';
  }

  exampleContents(): FieldContentsData {
    return { icon: { name: 'fa-solid fa-gauge-max' }, text: '100%' };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.targetMetric) {
      return {
        icon: { name: 'fa-solid fa-gauge-max' },
        text: record.targetMetric,
      };
    }

    return {};
  }
}
